import React from "react";
import "./surfPage.scss";
import TopBar from "../navigator/TopBar";
import { Outlet } from "react-router-dom";
import Footer from "../footer/Footer";

const UserSurf = () => {
  return (
    <>
      <TopBar />
      <Outlet />
      <Footer />
    </>
  );
};

export default UserSurf;
